<template>
    <div class="mt-l sm:mt-14 lg:mt-xxl lg:pt-xs">
        <div class="grid grid-cols-1 row-gap-xxl-2 md:grid-cols-3 md:col-gap-xl md:row-gap-xxl-2">
            <div v-for="article in paginationData.data" :key="article.id">
                <blog-header :article="article"
                             img-height="md:h-143px"
                             :url-blog-show="urlBlogShow"
                             :url-blog-category="urlBlogCategory"
                ></blog-header>
            </div>
        </div>

        <div id="load-more-button" class="text-center mt-xxl-2 vs-con-loading__container w-full" v-if="hasMorePages">
            <primary-button size="large" class="w-115px h-48px sm:w-auto sm:h-auto" title="See More" @click="fetchMoreArticles">
                <span>See More</span>
            </primary-button>
        </div>

    </div>
</template>

<script>
    import BlogHeader from "./BlogHeader";

    export default {
        name: "TabContent",

        props: {
            allArticles: {
                type: Object,
                required: true
            },
            urlBlogShow: {
                type: String,
                required: true
            },
            urlBlogCategory: {
                type: String,
                required: true
            },
            slug: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                paginationData: {
                    ...this.allArticles,
                    tempData: []
                },

                nextPageNumber: 2,
                perPage: 6
            }
        },

        components: {
            BlogHeader
        },

        computed: {
            hasMorePages() {
                return this.paginationData.tempData.length !== 0 ||
                    this.paginationData.next_page_url !== null;
            }
        },

        methods : {
            async fetchMoreArticles() {
                this.$vs.loading({
                    container: "#load-more-button",
                    scale: 0.6
                });


                let url = this.slug === "all"
                    ? `${this.urlBlogShow}?page=${this.nextPageNumber}`
                    : `${this.urlBlogCategory}/${this.slug}?page=${this.nextPageNumber}`;

                if (this.paginationData.tempData.length === 0) {

                    try {
                        const { data } = await axios.get(url);

                        this.setArticlesData( data, this.perPage );

                        this.nextPageNumber++;
                        this.$vs.loading.close('#load-more-button > .con-vs-loading');

                    } catch (error) {
                        console.log(error);
                    }

                } else {
                    setTimeout(() => {
                        const tempData = this.paginationData.tempData;
                        const currentDataSet = this.paginationData.data;

                        const nextDataSet = tempData.splice(0, this.perPage);
                        this.paginationData.data = currentDataSet.concat(nextDataSet);

                        if (tempData.length === 0) {
                            this.paginationData.tempData = [];
                        }

                        this.$vs.loading.close('#load-more-button > .con-vs-loading');
                    }, 300);
                }
            },

            setArticlesData(articles, perPage) {
                console.log(perPage);
                const firstDataSet = articles.data.slice(0, perPage);
                const remainingData = articles.data.slice(perPage);

                const data = {
                    ...articles,
                    data: this.paginationData.data.concat(firstDataSet),
                    tempData: remainingData
                }

                this.paginationData = data;
            }
        },

        watch: {
            allArticles: function (val) {
                this.paginationData = val
                this.paginationData.tempData = []
            },

            slug: function (val) {
                this.nextPageNumber = 2
            }
        },
    }
</script>

<style scoped>

</style>
